<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-tag"></i> 财务管理
                </el-breadcrumb-item>
				<el-breadcrumb-item>记账对账</el-breadcrumb-item>
				<el-breadcrumb-item>企税银对账</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <div class="handle-box">
				<el-date-picker
						type="month"
						placeholder="对账月份"
						v-model="query.month"
						value-format="yyyy-MM"
					></el-date-picker> &nbsp;
				<el-select v-model="query.orderType" placeholder="请选择订单类型" @change="queryOrderTypeChange">
					<el-option key="" label="请选择订单类型" value=""></el-option>
					<el-option key="0" label="采购" value="0"></el-option>
					<el-option key="1" label="销售" value="1"></el-option>
				</el-select>&nbsp;
				<el-select v-model="query.status" placeholder="请选择状态" filterable>
					<el-option key="" label="请选择状态" value=""></el-option>
					<el-option v-for="item in statusKV" :key="item.key" :label="item.value" :value="item.key"></el-option>
				</el-select>&nbsp;
				<el-select v-model="query.method" placeholder="请选择对账方式" filterable>
					<el-option key="" label="请选择对账方式" value=""></el-option>
					<el-option key=0 label="自动对账" value=0></el-option>
					<el-option key=1 label="手动对账" value=1></el-option>
				</el-select>&nbsp;
				<el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
            </div>
			<el-table
                :data="tableData"
                border
                class="table"
                ref="multipleTable"
                header-cell-class-name="table-header"
				:cell-style="{padding:4+'px'}"
				stripe
            >
				<el-table-column prop="month" label="对账月份" width="100"></el-table-column>
                <el-table-column prop="orderType" label="订单类型" :formatter="orderTypeFormat"></el-table-column>
				<el-table-column prop="orderAmount" label="含税订单金额"></el-table-column>
				<el-table-column prop="orderAmountNoTax" label="不含税订单金额" v-if=showNoTax></el-table-column>
				<el-table-column prop="bankAmount" label="对公金额"></el-table-column>
				<el-table-column prop="wechatAmount" label="现金金额"></el-table-column>
				<el-table-column prop="invoiceAmount" label="系统累计开票">
					<template slot-scope="scope">
						<el-tag :type= "scope.row.invoiceAmount > scope.row.realInvoiceAmount?'warning':(scope.row.invoiceAmount < scope.row.realInvoiceAmount?'danger':'success')" >{{scope.row.invoiceAmount}}
						</el-tag>
					</template>
				</el-table-column>
				<el-table-column prop="realInvoiceAmount" label="税务累计开票"></el-table-column>
				<el-table-column prop="status" label="状态">
					<template slot-scope="scope">
                        <el-tag :type="scope.row.status==0?'success':'error'">
							{{scope.row.status==0?"账已平":"账未平"}}
						</el-tag>
                    </template>
				</el-table-column>
				<el-table-column prop="method" label="对账方式">
					<template slot-scope="scope">
                        {{scope.row.method==0?"自动对账":"手动对账"}}
                    </template>
				</el-table-column>
				<el-table-column label="操作" width="150" align="center">
					<template slot-scope="scope">
						<el-button
                            type="text"
                            icon="el-icon-refresh-right"
                            @click="handleReconciliation(scope.$index, scope.row)"
							v-if="scope.row.status==1 && controll['fresh']"
                        >重新对账</el-button>
                        <el-button
                            type="text"
                            icon="el-icon-view"
                            @click="handleShowRecord(scope.$index, scope.row)"
							v-if="controll['show']"
                        >详情</el-button>
                    </template>
				</el-table-column>
            </el-table>
			<div class="record-a-d">
				<el-button
                    type="primary"
                    icon="el-icon-lx-add"
                    class="handle-del mr10"
                    @click="handleImport"
					v-if="controll['add']"
                >添加对账</el-button>
			</div>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total, prev, pager, next"
                    :current-page="query.pageIndex"
                    :page-size="query.pageSize"
                    :total="pageTotal"
                    @current-change="handlePageChange"
                ></el-pagination>
            </div>
        </div>
		
		<el-dialog v-dialogDrag :close-on-click-modal=false :title="reconciliationTitle" :visible.sync="recordVisible" width="80%">
			<el-table
                :data="recordData"
                border
                class="table"
                ref="recordTable"
                header-cell-class-name="table-header"
				:cell-style="{padding:4+'px'}"
				stripe
				height="520"
            >
                <el-table-column prop="companyName" label="公司名称" width="300"></el-table-column>
				<el-table-column prop="orderAmount" label="含税订单金额">
					<template slot-scope="scope">
						<el-tag :type= "scope.row.orderAmount == scope.row.bankAmount + scope.row.wechatAmount?'info':'warning'" >{{scope.row.orderAmount}} </el-tag>
					</template>
				</el-table-column>
				<el-table-column prop="orderAmountNoTax" label="不含税订单金额" v-if=showNoTax></el-table-column>
				<el-table-column prop="bankAmount" label="对公金额">
					<template slot-scope="scope">
						<el-tag :type= "scope.row.orderAmount == scope.row.bankAmount + scope.row.wechatAmount?'info':'warning'" >{{scope.row.bankAmount}} </el-tag>
					</template>
				</el-table-column>
				<el-table-column prop="wechatAmount" label="现金金额">
					<template slot-scope="scope">
						<el-tag :type= "scope.row.orderAmount == scope.row.bankAmount + scope.row.wechatAmount?'info':'warning'" >{{scope.row.wechatAmount}} </el-tag>
					</template>
				</el-table-column>
				<el-table-column prop="invoiceAmount" label="系统累计开票">
					<template slot-scope="scope">
						<el-tag :type= "scope.row.invoiceAmount > scope.row.realInvoiceAmount?'warning':(scope.row.invoiceAmount < scope.row.realInvoiceAmount?'danger':'success')" >{{scope.row.invoiceAmount}}
						</el-tag>
					</template>
				</el-table-column>
				<el-table-column prop="realInvoiceAmount" label="税务累计开票"></el-table-column>
				<el-table-column label="操作" width="150" align="center">
					<template slot-scope="scope">
                        <el-button
                            type="text"
                            icon="el-icon-view"
                            @click="handleView(scope.$index, scope.row)"
							v-if="controll['show']"
                        >记录</el-button>
                    </template>
				</el-table-column>
            </el-table>
		</el-dialog>
		
		<el-dialog v-dialogDrag :close-on-click-modal=false title="公司对账详情" :visible.sync="viewVisible" width="70%">
			<el-tabs v-model="activeName" type="card">
				<el-tab-pane label="订单记录" name="orderTab">
					<el-table
						:data="orders"
						border
						class="table"
						ref="multipleTable"
						header-cell-class-name="table-header"
						:cell-style="{padding:4+'px'}"
						stripe
					>
						<el-table-column prop="orderNo" label="订单号" width="130"></el-table-column>
						<el-table-column prop="orderCompanyName" label="供货公司"></el-table-column>
						<el-table-column prop="operator" label="经办人" width="90"></el-table-column>
						<el-table-column prop="total" label="数量" width="60"></el-table-column>
						<el-table-column prop="amount" label="金额" width="90"><template slot-scope="scope">￥{{scope.row.amount}}</template></el-table-column>
						<el-table-column prop="payType" label="付款方式" :formatter="payTypeFormat" width="100">
							<template slot-scope="scope" v-if="scope.row.status<6">
							<el-tag :type= "(scope.row.payReceipt > '' || scope.row.balancePayment > 0)?'success':((scope.row.payType===2 && new Date(scope.row.payTime).getTime() < new Date().getTime())?'danger':'warning')" >{{payTypeFormat(null, null, scope.row.payType)}}
							</el-tag>
							</template>
						</el-table-column>
						</el-table-column>
						<el-table-column prop="invoiceStatus" label="是否开票" width="90">
							<template slot-scope="scope" v-if="scope.row.status<6">
								<el-tag :type= "scope.row.taxIncluded?(scope.row.invoiceStatus?'success':'warning'):'info'" >{{scope.row.taxIncluded?(scope.row.invoiceStatus?'已开票':'未开票'):'无票'}} </el-tag>
							</template>
						</el-table-column>
						<el-table-column prop="status" label="订单状态" :formatter="statusFormat" width="80"></el-table-column>
						<el-table-column prop="createTime" label="下单时间" width="160"></el-table-column>
					</el-table>
				</el-tab-pane>
				<el-tab-pane label="银行流水" name="bankStatementTab">
					<el-table
						:data="bankStatements"
						border
						class="table"
						ref="multipleTable"
						header-cell-class-name="table-header"
						:cell-style="{padding:4+'px'}"
						stripe
					>
						<el-table-column prop="statementType" label="流水类型" :formatter="statementTypeFormat" width="120"></el-table-column>
						<el-table-column prop="financeType" label="财务类型" :formatter="financeTypeFormat" width="120"></el-table-column>
						<el-table-column prop="accountType" label="账户类型" :formatter="accountTypeFormat" width="120"></el-table-column>
						<el-table-column prop="companyName" label="对方公司"></el-table-column>
						<el-table-column prop="amount" label="交易金额" width="150"></el-table-column>
						<el-table-column prop="balance" label="余额" width="150"></el-table-column>
						<el-table-column prop="tranTime" label="交易时间" width="160"></el-table-column>
					</el-table>
				</el-tab-pane>
				<el-tab-pane label="发票记录" name="taxTab">
					<el-table
						:data="taxs"
						border
						class="table"
						ref="multipleTable"
						header-cell-class-name="table-header"
						:cell-style="{padding:4+'px'}"
						stripe
					>
						<el-table-column prop="invoiceCode" label="发票代码" width="200"></el-table-column>
						<el-table-column prop="invoiceNo" label="发票编号" width="200"></el-table-column>
						<el-table-column prop="channelName" label="客户名称"></el-table-column>
						<el-table-column prop="invoiceAccountTax" label="金额" width="200"></el-table-column>
						<el-table-column prop="invoiceDate" label="开票日期" width="200"></el-table-column>
					</el-table>
				</el-tab-pane>
			</el-tabs>
		</el-dialog>

        <!-- 编辑弹出框 -->
        <el-dialog v-dialogDrag :close-on-click-modal=false title="导入对账" :visible.sync="importVisible" width="80%">
			<el-form ref="form" :model="form">
				<el-form-item label="订单类型" prop="orderType">
					<el-select v-model="form.orderType" placeholder="请选择订单类型" @change="formOrderTypeChange">
						<el-option key="" label="请选择订单类型" value=""></el-option>
						<el-option key="0" label="采购" value="0"></el-option>
						<el-option key="1" label="销售" value="1"></el-option>
					</el-select>
                </el-form-item>
            </el-form>
            <el-table
                :data="importTableData"
                border
                class="table"
                ref="multipleTable"
                header-cell-class-name="table-header"
				:cell-style="{padding:4+'px'}"
				height="410px"
				stripe
            >
                <el-table-column prop="month" label="对账月份" :formatter="getMonth"></el-table-column>
                <el-table-column prop="orderType" label="订单类型" :formatter="orderTypeFormat"></el-table-column>
				<el-table-column prop="companyName" label="公司名称" width="300"></el-table-column>
				<el-table-column prop="orderAmount" label="含税订单金额">
					<template slot-scope="scope">
						<el-tag :type= "scope.row.orderAmount == scope.row.bankAmount + scope.row.wechatAmount?'info':'warning'" >{{scope.row.orderAmount}} </el-tag>
					</template>
				</el-table-column>
				<el-table-column prop="orderAmountNoTax" label="不含税订单金额" v-if=showNoTax></el-table-column>
				<el-table-column prop="bankAmount" label="对公金额">
					<template slot-scope="scope">
						<el-tag :type= "scope.row.orderAmount == scope.row.bankAmount + scope.row.wechatAmount?'info':'warning'" >{{scope.row.bankAmount}} </el-tag>
					</template>
				</el-table-column>
				<el-table-column prop="wechatAmount" label="现金金额">
					<template slot-scope="scope">
						<el-tag :type= "scope.row.orderAmount == scope.row.bankAmount + scope.row.wechatAmount?'info':'warning'" >{{scope.row.wechatAmount}} </el-tag>
					</template>
				</el-table-column>
				<el-table-column prop="invoiceAmount" label="系统累计开票">
					<template slot-scope="scope">
						<el-tag :type= "scope.row.invoiceAmount > scope.row.realInvoiceAmount?'warning':(scope.row.invoiceAmount < scope.row.realInvoiceAmount?'danger':'success')" >{{scope.row.invoiceAmount}}
						</el-tag>
					</template>
				</el-table-column>
				<el-table-column prop="realInvoiceAmount" label="税务累计开票">
				</el-table-column>
            </el-table>
            <span slot="footer" class="dialog-footer">
				<el-button @click="importVisible = false">取 消</el-button>
				<el-button type="primary" @click="save" v-prevent-re-click>导入</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import bus from '../../common/bus';
import { getControll } from '../../../utils/controlls';
import { fetchReconciliationData, saveReconciliation, fetchBillToBeConfirm, getReconciliationRecord, 
getChannelKV, getAllCustomerKV, getReconciliationBankStatements, fetchReconciliationOrders, 
fetchReconciliationSalesData, fetchIncomeData, isShowNoTax, freshReconciliation } from '../../../api/index';
export default {
    name: 'reconciliation',
    data() {
        return {
            query: {
                pageNum: 1,
                pageSize: 10
            },
            tableData: [],
			pageTotal:0,
			importVisible:false,
			viewVisible:false,
			importTableData: [],
			form:{},
			content:{},
			fileList:[],
			previewData:[],
			uuid:"",
			queryCompanysKV:[],
			orders:[],
			bankStatements:[],
			taxs:[],
			activeName:"orderTab",
			showNoTax:false,
			controll:{},
			reconciliationTotal:{},
			recordData:[],
			recordVisible:false,
			reconciliationTitle:"",
			month:"",
			orderType:"",
			statusKV:[{"key":0,"value":"账已平"}, {"key":1,"value":"账不平"}]
        };
    },
    created() {
		this.controll = getControll("reconciliation");
		bus.$on('reconciliation', msg => {
            for (var key in msg) {
				this.query[key] = msg[key];
			}
			this.getData();
        });
		this.getShowNoTax();
        this.getData();
    },
    methods: {
		getShowNoTax() {
			isShowNoTax().then(res => {
				if (res.code == 0) {
					this.showNoTax = res.data;
				} else {
					this.$message.error(`获取显示配置失败！` + res.message);
				}
			});
		},
		//流水类型
		orderTypeFormat(row, column, cellValue) {
			let arrivalStatusConfig = {"0":"采购", "1":"销售"};
			return arrivalStatusConfig[cellValue];
		},
		getMonth(row, column, cellValue){
			return this.reconciliationTotal.month;
		},
		payTypeFormat(row, column, cellValue) {
			let payTypeConfig = {"0":"款到发货", "1":"快递代收", "2":"账期付款"};
			return payTypeConfig[cellValue];
		},
		//流水类型
		statementTypeFormat(row, column, cellValue) {
			let arrivalStatusConfig = {"0":"收入", "1":"支出"};
			return arrivalStatusConfig[cellValue];
		},
		//财务类型
		financeTypeFormat(row, column, cellValue) {
			let statusConfig = {"10":"货款","11":"采购退款","12":"利息","13":"借款","14":"货款拆分平账","20":"采购款","21":"货款退款","22":"工资","23":"报销","24":"还款","25":"手续费","26":"社保","27":"国税","28":"采购款拆分平账","0":"其他"};
			return statusConfig[cellValue];
		},
		statusFormat(row, column, cellValue) {
			let statusConfig = {"0":"待审核","1":"待付款","2":"待收货","3":"收货中","4":"已到货","5":"已完结","6":"已撤销"};
			return statusConfig[cellValue];
		},
		accountTypeFormat(row, column, cellValue) {
			let accountTypeConfig = {"0":"公账","1":"微信/支付宝","2":"现金"};
			return accountTypeConfig[cellValue];
		},
		queryOrderTypeChange(value) {
			this.queryCompanysKV = [];
			if (value === "") {
				this.query.companyId = "";
				return;
			}
			let execQuery = value === "0"?getChannelKV:getAllCustomerKV;
			execQuery().then(res => { 
				if (res.code == 0 ) {
					this.queryCompanysKV = res.data;
				} else {
					this.$message.error("获取公司信息失败");
				}
            });
		},
        // 获取数据
        getData() {
            fetchReconciliationData(this.query).then(res => { 
				if (res.code == 0 ) {
					this.tableData = res.data.records;
					this.pageTotal = res.data.total;
				} else {
					this.$message.error(res.message);
				}
            });
        },
        // 触发搜索按钮
        handleSearch() {
            this.$set(this.query, 'pageNum', 1);
			this.$set(this.query, 'pageIndex', 1);
            this.getData();
        },
        // 保存编辑
        save() {
			saveReconciliation(this.uuid).then(res => {
				if (res.code == 0) {
					this.$message.success('导入成功！');
					this.importVisible = false;
					this.getData();
				} else {
					this.$message.error(`导入失败！` + res.message);
				}
			});
        },
		handleImport() {
			this.form.orderType = "";
			this.importTableData = [];
			this.importVisible = true;
		},
		formOrderTypeChange() {
			if (this.form.orderType == "") return;
			fetchBillToBeConfirm(this.form.orderType).then(res => {
				if (res.code == 0) {
					this.importTableData = res.data.records;
					this.$set(this.reconciliationTotal, "orderType", res.data.orderType);
					this.$set(this.reconciliationTotal, "month", res.data.month);
					this.$set(this.reconciliationTotal, "orderAmount", res.data.orderAmount);
					this.$set(this.reconciliationTotal, "orderAmountNoTax", res.data.orderAmountNoTax);
					this.$set(this.reconciliationTotal, "bankAmount", res.data.bankAmount);
					this.$set(this.reconciliationTotal, "wechatAmount", res.data.wechatAmount);
					this.$set(this.reconciliationTotal, "invoiceAmount", res.data.invoiceAmount);
					this.$set(this.reconciliationTotal, "realInvoiceAmount", res.data.realInvoiceAmount);
					this.uuid = res.data.uuid;
				} else {
					this.$message.error(`获取对账单失败！` + res.message);
				}
				
			});
		},
		handleView(index, row) {
			let orderParam = {};
			orderParam["orderType"] = this.orderType;
			orderParam["orderCompanyId"] = row.companyId;
			orderParam["createTimeStart"] = this.month + "-01 00:00:00";
			var date = new Date(orderParam["createTimeStart"]);
			var y = date.getFullYear();
			var m = date.getMonth();
			var lastDay = new Date(y, m + 1, 0);
			orderParam["createTimeEnd"] = this.month + "-" + lastDay.getDate() + " 23:59:59";
			let bankStatementsParam = {};
			bankStatementsParam["statementType"] = this.orderType;
			bankStatementsParam["companyId"] = row.companyId;
			bankStatementsParam["tranTimeStart"] = orderParam["createTimeStart"];
			bankStatementsParam["tranTimeEnd"] = orderParam["createTimeEnd"];
			getReconciliationBankStatements(bankStatementsParam).then(res => {
				if (res.code == 0) {
					this.bankStatements = res.data.records;
				} else {
					this.$message.error(`获取银行流水失败！` + res.message);
					return;
				}
			});
			fetchReconciliationOrders(orderParam).then(res => {
				if (res.code == 0) {
					this.orders = res.data.records;
				} else {
					this.$message.error(`获取订单失败！` + res.message);
					return;
				}
			});
			if (this.orderType == 0) {
				let incomeParam = {};
				incomeParam["channelId"] = row.companyId;
				incomeParam["invoiceDateStart"] = this.month + "-01";
				incomeParam["invoiceDateEnd"] = this.month + "-" + lastDay.getDate();
				incomeParam["pageSize"] = 100;
				fetchIncomeData(incomeParam).then(res => {
					if (res.code == 0) {
						this.taxs = res.data.records;
						this.activeName="orderTab";
						this.viewVisible = true;
					} else {
						this.$message.error(`获取进项票失败！` + res.message);
						return;
					}
				});
			} else {
				let salesParam = {};
				salesParam["customerId"] = row.companyId;
				salesParam["billTimeStart"] = this.month + "-01";
				salesParam["billTimeEnd"] = this.month + "-" + lastDay.getDate();
				fetchReconciliationSalesData(salesParam).then(res => {
					if (res.code == 0) {
						let result = [];
						for (var index in res.data) {
							let resultItem = {};
							resultItem["invoiceCode"] = res.data[index]["invoiceCode"];
							resultItem["invoiceNo"] = res.data[index]["invoiceNo"];
							resultItem["channelName"] = res.data[index]["customerName"];
							resultItem["invoiceAccount"] = res.data[index]["amount"];
							resultItem["invoiceDate"] = res.data[index]["billTime"];
							result.push(resultItem);
						}
						this.taxs = result;
						this.activeName="orderTab";
						this.viewVisible = true;
					} else {
						this.$message.error(`获取销项票失败！` + res.message);
						return;
					}
				});
			}
		},
        // 分页导航
        handlePageChange(val) {
            this.$set(this.query, 'pageNum', val);
			this.$set(this.query, 'pageIndex', val);
            this.getData();
        },
		handleShowRecord(index, row) {
			getReconciliationRecord(row.id).then(res => {
				if (res.code == 0) {
					this.recordData=res.data;
					this.month = row.month;
					this.orderType = row.orderType;
					this.reconciliationTitle = row.month + "期" + (row.orderType==0?"采购":"销售") 
					+ "对账公司记录详情";
					this.recordVisible = true;
				} else {
					this.$message.error(`获取详情记录失败！` + res.message);
				}
			});
		},
		handleReconciliation(index, row) {
			this.$confirm('确定要重新对账吗？', '提示', {
                type: 'warning'
            }).then(() => {
				freshReconciliation(row.id).then(res => {
					if (res.code == 0) {
						this.$message.success(`重新对账完成！`);
						this.getData();
					} else {
						this.$message.error(`重新对账失败！` + res.message);
					}
				});
			})
			.catch(() => {});
		}
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
.record-a-d {
	float:left; 
	padding-top:20px;
}
</style>
